import Typography from "aldoo-ra/Typography"
import { CheckIcon as Check } from "@heroicons/react/24/outline"
import TiltWrapper from "../../TiltWrapper"

function SectionBadge({ children }) {
  return (
    <span className="inline-block w-fit rounded-full bg-gradient-to-br from-secondary/50 to-accent  text-white text-xs font-semibold uppercase tracking-wide px-3 py-1 mb-3 lg:mb-1">
      {children}
    </span>
  )
}

function CheckRow({ children }) {
  return (
    <li className="flex items-start gap-3">
      <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 rounded-full bg-gradient-to-r from-secondary/50 to-accent/70 mt-0.5">
        <Check className="w-3 h-3 text-white stroke-[4]" />
      </span>

      <Typography variant="txt" className="text-left text-text my-0">
        {children}
      </Typography>
    </li>
  )
}

export default function MainSection({ badge, title, description, bullets, mockup, reverse }) {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <div className={`relative z-10 w-full max-w-6xl mx-auto px-6 flex flex-col-reverse ${reverse ? "lg:flex-row-reverse" : "lg:flex-row"} items-center gap-12 lg:gap-16`}>
        <div className="flex-1 w-full flex justify-center">
          <TiltWrapper className="w-full flex justify-center">
            {mockup}
          </TiltWrapper>
        </div>

        <div className="w-full lg:w-[45%] max-w-[560px] lg:max-w-auto flex flex-col items-center lg:items-start text-center lg:text-left flex-shrink-0">
          <SectionBadge>{badge}</SectionBadge>

          <Typography
            component="h2"
            variant="h3"
            className="mb-4"
          >
            {title}
          </Typography>

          <Typography variant="body1_dim" className="my-2">
            {description}
          </Typography>

          <ul className="space-y-5 lg:space-y-3 mb-0">
            {bullets.map((b, i) => <CheckRow key={i}>{b}</CheckRow>)}
          </ul>
        </div>
      </div>
    </section>
  )
}